import { render, staticRenderFns } from "./ShippingMethods.vue?vue&type=template&id=7fa50419&scoped=true&lang=pug&"
import script from "./ShippingMethods.vue?vue&type=script&lang=js&"
export * from "./ShippingMethods.vue?vue&type=script&lang=js&"
import style0 from "./ShippingMethods.vue?vue&type=style&index=0&id=7fa50419&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa50419",
  null
  
)

/* custom blocks */
import block0 from "./ShippingMethods.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports